import { getSecret } from "../util/get-secret.js";
import { AddressType, Client, Status } from "@googlemaps/google-maps-services-js";
const client = new Client({});
export async function searchGooglePlaces({ queryText = "", geoModifiers = "" }) {
    const { GOOGLE_MAPS_API_KEY } = await getSecret("GOOGLE_MAPS_API_KEY");
    const params = {
        key: GOOGLE_MAPS_API_KEY,
        query: `${queryText} ${geoModifiers}`,
        fields: ["name", "place_id", "formatted_address", "business_status"],
    };
    const { data: { results, status, error_message } } = await client.textSearch({ params });
    if (status === Status.OK) {
        return results.filter((p) => !p.types?.includes(AddressType.street_address));
    }
    else if (status !== Status.ZERO_RESULTS) {
        throw new Error(`${status}: ${error_message || ''}`);
    }
}
//# sourceMappingURL=search-google-places.js.map